import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { GridColDef, GridPaginationModel } from '@mui/x-data-grid';
import { RootState } from '../../../../../redux/store';

import { PqrTimesListActions } from './actions';

import { DateTooltip } from '../../../../components/general/dateTooltip';
import { isOnlyViewProfile } from '../../../../../shared/types/profiles';
import { ISelect } from '../../../../../shared/types/shared';
import {
    PqrTimeFilter,
    PqrTime,
} from '../../../../../shared/types/paramPqrTimes';
import { asyncGetPqrTimes } from '../../../../../services/pqr-times.service';

export const usePqrTimesList = (filters?: PqrTimeFilter) => {
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState<PqrTime[]>([]);
    const [page, setPage] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(10);
    const [total, setTotal] = useState<number>(0);
    const [finalFilters, setFinalFilters] = useState<PqrTimeFilter>({});

    const paginator = (model: GridPaginationModel) => {
        if (model.page !== page) {
            setPage(model.page);
        } else if (model.pageSize !== pageSize) {
            setPageSize(model.pageSize);
        }
    };

    const columns: GridColDef<PqrTime>[] = [];

    if (!isOnlyViewProfile(type)) {
        columns.push({
            field: 'actions',
            headerName: 'Acciones',
            width: 100,
            sortable: false,
            disableColumnMenu: true,
            filterable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (row) => <PqrTimesListActions id={row.row.id || ''} />,
        });
    }

    columns.push(
        {
            field: 'rule',
            headerName: 'No. Regla',
            minWidth: 50,
            flex: 0.2,
        },
        {
            field: 'name',
            headerName: 'Nombre',
            minWidth: 150,
            flex: 0.9,
        },
        {
            field: 'typeDay',
            headerName: 'Fecha base para calculo de días',
            minWidth: 80,
            flex: 0.4,
            align: 'center',
            headerAlign: 'center',
            renderCell: (row) => (
                <>{(row.row.typeDay as ISelect)?.name || ''}</>
            ),
        },
        {
            field: 'active',
            headerName: 'Activo',
            minWidth: 80,
            flex: 0.2,
            align: 'center',
            headerAlign: 'center',
            renderCell: (row) => <>{row.row.active ? 'Si' : 'No'}</>,
        },
        {
            field: 'created_at',
            headerName: 'Fecha de creación',
            minWidth: 120,
            flex: 0.4,
            align: 'center',
            headerAlign: 'center',
            renderCell: (row) => <DateTooltip date={row.row.created_at} />,
        }
    );

    useEffect(() => {
        setPage(0);
        setFinalFilters(filters || {});
    }, [filters]);

    useEffect(() => {
        setLoading(true);
        asyncGetPqrTimes(finalFilters, page, pageSize)
            .then((res) => {
                setRows(res.items);
                setTotal(res.length);
            })
            .finally(() => setLoading(false));
    }, [page, pageSize, finalFilters]);

    return {
        columns,
        rows,
        page,
        pageSize,
        paginator,
        loading,
        total,
    };
};
